export default "__VITE_ASSET__ClGy4$3W__"